import React, { useEffect } from 'react'
import "./MobileServices.css"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Color3 from "../../../../asset/images/vectors/color3.webp";
import Color4 from "../../../../asset/images/vectors/color4.webp";
import { WOW } from 'wowjs';
import 'animate.css';



const MobileServices = () => {
    useEffect(() => {
        new WOW().init();
    }, []);

    return (
        <div className='mobile-services'>
            <div className="color-div2">
                <img id="color3" src={Color3} alt="color3" />
                <img id="color4" src={Color4} alt="color4" />
            </div>
            <div className='mobile-services-container container'>
                <Row className='mobile-services-rows-container'>
                    <Row className='mobile-services-row odd-row'>
                        <Col xs={12} md={6}>

                            <div className='mobile-service-container'>
                                <div className='mobile-service-col-content'>
                                    <img className=' wow animate__animated animate__slideInLeft' data-wow-duration="1.5s" src={require('../../../../asset/images/MobileService/mobile-service-1.webp')} alt='device-gallery' />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className='mobile-service-container'>
                                <div className='mobile-service-col-content'>
                                    <div className='mobile-service-text-content  wow animate__animated animate__slideInRight' data-wow-duration="1.5s">
                                        <div className='mobile-service-text-title'>
                                            <span>Cross-Platform Compatibility</span>
                                        </div>
                                        <div className='mobile-service-text-des'>
                                            <span>Develop mobile applications that run smoothly across multiple platforms, including iOS and Android. This service ensures your app can reach a wider audience without sacrificing functionality or user experience on any device.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='arrow-container' data-aos="fade-down" data-aos-duration="1500">
                        <img src={require('../../../../asset/images/MobileService/arrow.png')} alt='arrow' />
                    </div>

                    <Row className='mobile-services-row'>
                        <Col xs={12} md={6}>
                            <div className='mobile-service-container'>
                                <div className='mobile-service-col-content'>
                                    <div className='mobile-service-text-content  wow animate__animated animate__slideInLeft' data-wow-duration="1.5s">
                                        <div className='mobile-service-text-title'>
                                            <span>AI-Enhanced Mobile Applications</span>
                                        </div>
                                        <div className='mobile-service-text-des'>
                                            <span>Incorporate advanced artificial intelligence into your mobile apps to automate processes, personalize user experiences, and gain insights from data. Ideal for businesses looking to leverage AI for smarter decision-making and enhanced user engagement.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className='mobile-service-container'>
                                <div className='mobile-service-col-content'>
                                    <img className=' wow animate__animated animate__slideInRight' data-wow-duration="1.5s" src={require('../../../../asset/images/MobileService/mobile-service-2.webp')} alt='device-gallery' />
                                </div>
                            </div>
                        </Col>
                    </Row>




                    <div className='arrow-container' data-aos="fade-down" data-aos-duration="1500">
                        <img src={require('../../../../asset/images/MobileService/arrow-reverse.png')} alt='arrow' />
                    </div>

                    <Row className='mobile-services-row odd-row'  >
                        <Col xs={12} md={6}>
                            <div className='mobile-service-container'>
                                <div className='mobile-service-col-content'>
                                    <img className='wow animate__animated animate__slideInLeft' data-wow-duration="1.5s" src={require('../../../../asset/images/MobileService/mobile-service-3.webp')} alt='device-gallery' />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className='mobile-service-container'>
                                <div className='mobile-service-col-content'>
                                    <div className='mobile-service-text-content wow animate__animated animate__slideInRight' data-wow-duration="1.5s" >
                                        <div className='mobile-service-text-title'>
                                            <span>Real-Time Data Analytics</span>
                                        </div>
                                        <div className='mobile-service-text-des'>
                                            <span>Equip your app with real-time data analytics capabilities to monitor user behavior and app performance instantly. This service is crucial for businesses that need to make quick decisions based on up-to-the-minute data.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className='arrow-container' data-aos="fade-down" data-aos-duration="1500">
                        <img src={require('../../../../asset/images/MobileService/arrow.png')} alt='arrow' />
                    </div>

                    <Row className='mobile-services-row' >
                        <Col xs={12} md={6}>
                            <div className='mobile-service-container'>
                                <div className='mobile-service-col-content'>
                                    <div className='mobile-service-text-content  wow animate__animated animate__slideInLeft' data-aos-duration="1500">
                                        <div className='mobile-service-text-title' >
                                            <span>Seamless Payment Gateway Integration</span>
                                        </div>
                                        <div className='mobile-service-text-des'>
                                            <span>Enhance your mobile application with secure and seamless payment gateway integration, allowing for easy and efficient transactions. Perfect for e-commerce and service-based platforms aiming to provide a smooth user checkout experience.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className='mobile-service-container'>
                                <div className='mobile-service-col-content'>
                                    <img className=' wow animate__animated animate__slideInRight' data-aos="fade-right" data-aos-duration="3000" src={require('../../../../asset/images/MobileService/mobile-service-4.webp')} alt='device-gallery' />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Row>

            </div>

        </div>
    )
}

export default MobileServices
